<form
  [formGroup]="frm"
  novalidate
  class="grid grid-cols-1 lg:grid-cols-2 gap-x-4 gap-y-3">
  <!-- Name -->
  <mat-form-field>
    <mat-label>Nombre</mat-label>
    <input
      matInput
      type="text"
      placeholder="Nombre"
      formControlName="first_name" />
    @if (first_name.hasError('required')) {
      <mat-error>El nombre es requerido</mat-error>
    }
    @if (first_name.hasError('maxlength')) {
      <mat-error>El nombre no debe exceder de los 50 caracteres</mat-error>
    }
  </mat-form-field>

  <!-- Last Name -->
  <mat-form-field>
    <mat-label>Apellidos</mat-label>
    <input
      matInput
      type="text"
      placeholder="Apellidos"
      formControlName="last_name" />
    @if (last_name.hasError('required')) {
      <mat-error>Los apellidos son requeridos </mat-error>
    }
    @if (last_name.hasError('maxlength')) {
      <mat-error>Los apellidos no debe exceder de los 50 caracteres</mat-error>
    }
  </mat-form-field>

  <!-- Email -->
  <mat-form-field>
    <mat-label>Correo</mat-label>
    <input matInput placeholder="Correo electrónico" formControlName="email" />
    @if (email.hasError('exist')) {
      <mat-error>El correo no está disponible</mat-error>
    }
    @if (email.hasError('required')) {
      <mat-error>El correo es requerido</mat-error>
    }
    @if (email.hasError('email')) {
      <mat-error>El correo no es válido</mat-error>
    }
  </mat-form-field>

  <!-- Phone -->
  <store-phone-input
    [countryFormControl]="country_code"
    [phoneFormControl]="phone">
  </store-phone-input>
</form>
<div class="flex justify-end mt-1">
  <button
    mat-flat-button
    (click)="onSubmit()"
    [disabled]="loading() || frm.pristine">
    @if (loading()) {
      <mat-spinner class="mx-3" [diameter]="20"></mat-spinner>
    } @else {
      <ng-container>Guardar</ng-container>
    }
  </button>
</div>
